import { useGetDaasEntities } from './useGetDaasEntities';

export const useGetDaasProjects = (
  userOwnedProjects: boolean = false,
  userInSecurityGroup: boolean = false,
) => {
  return useGetDaasEntities(
    'daas-project',
    userOwnedProjects,
    userInSecurityGroup,
  );
};
